import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "./useNavigate";

export function useNavigateToWizard() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  return useCallback((wizardStepId: string) => {
    if (!id){
      throw new Error("ID not found");
    }

    return navigate(
      `/mobile-device-setup/tutorials/${id}/${wizardStepId}`
    );
  }, [navigate, id]);
}
